import React, { useState } from "react";
import { Button, TextField } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios"; // Import axios
import { test_ip } from "../services/constants";
import "./Courier.css"; // Import your CSS file
import { Alert } from "@mui/material";
import { check_error_code } from "../services/error_string";
import Loading from "../components/Loading";

const Courier = () => {
  const UserLocation = JSON.parse(localStorage.getItem("userLocation"));
  const [error, setError] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { pickup, dropoff, pickupCoordinates, dropoffCoordinates } =
    location.state || {};
  const userData = JSON.parse(localStorage.getItem("user"));
  // console.log(userData)
  const fullname = userData.first_name + " " + userData.last_name;
  if (dropoff && dropoff === "Current Location") {
    var lat;
    var lng;
    if (UserLocation) {
      lat = UserLocation.latitude;
      lng = UserLocation.longitude;
    } else {
      lat = 8.905;
      lng = 9.6777;
    }
    dropoffCoordinates.lat = lat;
    dropoffCoordinates.lng = lng;
    console.log("cuurent location in drop"); //read lat n lon from localsotrage
    // console.log(dropoffCoordinates);
  }
  if (pickup && pickup === "Current Location") {
    console.log("cuurent locaion in pickup");
    var lat;
    var lng;
    console.log(UserLocation);
    if (UserLocation) {
      lat = UserLocation.latitude;
      lng = UserLocation.longitude;
    } else {
      lat = 8.905;
      lng = 9.6777;
    }

    pickupCoordinates.lat = lat;
    pickupCoordinates.lng = lng;
    // console.log(pickupCoordinates);
    // console.log(pickupCoordinates);
  }
  // State to handle form inputs
  const [senderName, setSenderName] = useState(fullname);
  const [senderPhone, setSenderPhone] = useState(userData.phone);
  const [receiverName, setReceiverName] = useState("");
  const [receiverPhone, setReceiverPhone] = useState("");
  const [description, setDescription] = useState("");

  const handleLocationClick = (type) => {
    navigate("/kcolocations", {
      state: {
        type,
        pickup,
        dropoff,
        pickupCoordinates,
        dropoffCoordinates,
      },
    });
  };
  const handleContinue = async (e) => {
    e.preventDefault();
    console.log(pickup);
    console.log(dropoff);
    setLoading(true);
    var message = "";

    // Check for pickup location
    if (!pickup || pickup === null || pickup === undefined) {
      message = "Please Select Pickup Location first";
    }
    // Check for dropoff location
    else if (!dropoff || dropoff === null || dropoff === undefined) {
      message = "Please Select Dropoff Location first";
    }
    // Check for sender details
    else if (!senderName) {
      message = "Please Enter Sender Name.";
    } else if (!senderPhone) {
      message = "Please Enter Sender Phone number.";
    } else if (senderPhone.length !== 9) {
      message = "Sender Phone number must be exactly 9 digits long.";
    }
    // Check for receiver details
    else if (!receiverName) {
      message = "Please Enter Receiver Name.";
    } else if (!receiverPhone) {
      message = "Please Enter Receiver Phone number.";
    } else if (receiverPhone.length !== 9) {
      message = "Receiver Phone number must be exactly 9 digits long.";
    }
    // If there's any message, set the error and return early
    if (message) {
      setError([message]);
      setLoading(false);
      return;
    }

    try {
      const payload = {
        user_id: userData.user_id,
        user_type: userData.admin_type, // Same as in your Flutter code
        store_id: "",
        city_id: "5b406b46d2ddf8062d11b788", // Assuming provider is available in your context
        destination_addresses: [
          {
            user_type: 7,
            user_details: {
              phone: receiverPhone,
              name: receiverName,
              email: "",
              country_phone_code: "+251", // Assuming provider is available in your context
            },
            note: description,
            location: [dropoffCoordinates.lat, dropoffCoordinates.lng],
            delivery_status: 0,
            city: userData.city,
            address_type: "destination",
            address: dropoff,
          },
        ],
        order_details: [],
        pickup_addresses: [
          {
            user_type: userData.admin_type,
            user_details: {
              phone: senderPhone,
              name: senderName,
              country_phone_code: "+251", // Assuming provider is available in your context
            },
            note: description,
            location: [pickupCoordinates.lat, pickupCoordinates.lng],
            delivery_status: 0,
            city: userData.city,
            address_type: "pickup",
            address: pickup, // _controller.text equivalent
          },
        ],
        total_cart_price: "0",
        total_item_tax: 0,
        cart_unique_token: userData.server_token,
        server_token: userData.server_token,
        delivery_type: 2,
      };

      console.log("Payload to send:", payload); // Log the payload for debugging

      const response = await axios.post(
        `${test_ip}api/user/add_item_in_cart`,
        payload
      );

      // Handle successful response
      console.log(pickupCoordinates);
      console.log(dropoffCoordinates);
      console.log("Item added to cart:");
      console.log(response.data);

      // Check if the response indicates success
      if (response.data.success) {
        const cartData = response.data.cart; // Assuming response.data contains the cart
        localStorage.setItem("courier_cart", JSON.stringify(cartData));
        console.log("Cart data stored in local storage:", cartData);
        // Prepare the payload for the second API call
        const vehicleListPayload = {
          store_id: "",
          type: 7,
          delivery_type: 2,
          user_id: userData.user_id, // Use the same user_id as in the first request
          server_token: userData.server_token, // Use the same server_token as in the first request
          city_id: "5b406b46d2ddf8062d11b788", // Same city_id
        };

        console.log("Payload for vehicle list:", vehicleListPayload); // Log for debugging

        // Make the second API call
        const vehicleListResponse = await axios.post(
          `${test_ip}api/store/get_vehicle_list`,
          vehicleListPayload
        );

        // Handle successful response for the vehicle list
        console.log("Vehicle list retrieved:", vehicleListResponse.data);

        // Check if the second response indicates success
        if (vehicleListResponse.data.success) {
          // Store the vehicle data in local storage
          // Store them in local storage
          localStorage.setItem(
            "pickupCoordinates",
            JSON.stringify(pickupCoordinates)
          );
          localStorage.setItem(
            "dropoffCoordinates",
            JSON.stringify(dropoffCoordinates)
          );
          localStorage.setItem(
            "vehicleList",
            JSON.stringify(vehicleListResponse.data.vehicles)
          );
        } else {
          var message = check_error_code(response.data.error_code);
          setError([message]);
        }
        console.log("navigate");
        // Optionally handle further logic here, like updating state or navigating
        navigate("/select-vehicle"); // Change the path according to your routing structure
      } else {
        var message = check_error_code(response.data.error_code);
        setError([message]);
      }
    } catch (error) {
      console.error("Error adding item to cart:", error);
      // Optionally, show an error message to the user
    } finally {
      setLoading(false); // Set loading to false when the API call is complete (whether success or error)
    }
  };

  // Handle continue button click
  // const handleContinue = async () => {
  //   try {
  //     const payload = {
  //       user_id: userData.user_id, // Ensure userData is defined and accessible
  //       user_type: userData.admin_type, // Same as in your Flutter code
  //       store_id: "",
  //       city_id: "5b406b46d2ddf8062d11b788", // Assuming provider is available in your context
  //       destination_addresses: [
  //         {
  //           user_type: 7,
  //           user_details: {
  //             phone: receiverPhone,
  //             name: receiverName,
  //             email: "",
  //             country_phone_code:"+251", // Assuming provider is available in your context
  //           },
  //           note: description,
  //           location: [dropoffCoordinates.lat, dropoffCoordinates.lng],
  //           delivery_status: 0,
  //           city: userData.city,
  //           address_type: "destination",
  //           address: dropoff,
  //         }
  //       ],
  //       order_details: [],
  //       pickup_addresses: [
  //         {
  //           user_type: userData.admin_type,
  //           user_details: {
  //             phone: senderPhone,
  //             name: senderName,
  //             country_phone_code:"+251", // Assuming provider is available in your context
  //           },
  //           note: description,
  //           location: [pickupCoordinates.lat, pickupCoordinates.lng],
  //           delivery_status: 0,
  //           city: userData.city,
  //           address_type: "pickup",
  //           address: pickup, // _controller.text equivalent
  //         }
  //       ],
  //       total_cart_price: "0",
  //       total_item_tax: 0,
  //       cart_unique_token: userData.server_token,
  //       server_token: userData.server_token,
  //       delivery_type: 2,
  //     };

  //     console.log("Payload to send:", payload); // Log the payload for debugging

  //     const response = await axios.post(`${test_ip}api/user/add_item_in_cart`, payload);

  //     // Handle successful response
  //     console.log("Item added to cart:")
  //     console.log(response.data);
  //     // if(response.data.success){
  //     //   const data={

  //     //   }
  //     //   const response = await axios.post(`${test_ip}api/store/get_vehicle_list`, data);

  //     // }
  //     // Optionally, navigate to another page or show a success message
  //     // navigate("/next-page"); // Example of navigation after successful API call

  //   } catch (error) {
  //     console.error("Error adding item to cart:", error);
  //     // Optionally, show an error message to the user
  //   }
  // };

  return (
    <div style={{ backgroundColor: "white" }}>
      <div className="b-login-page">
        <div className="b-contain">
          <h4 style={{ marginTop: 0 }}>Courier Delivery</h4>
          <Button
            className="b-login-btn"
            size="small"
            style={{ marginBottom: "10px" }}
            onClick={() => handleLocationClick("pickup")}
            startIcon={<LocationOnIcon />}
          >
            {pickup || "Pickup Address"}
          </Button>
          <Button
            className="b-login-btn"
            size="small"
            style={{ marginBottom: "18px" }}
            onClick={() => handleLocationClick("dropoff")}
            startIcon={<LocationOnIcon />}
          >
            {dropoff || "Drop-off Address"}
          </Button>
          {/* Sender Information */}
          <TextField
            id="outlined-password-input"
            label="Sender Name"
            type="text"
            value={senderName}
            onChange={(e) => setSenderName(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            id="outlined-password-input"
            label="+251"
            value={senderPhone}
            type="tel"
            onChange={(e) => {
              const value = e.target.value;
              // Only allow digits (0-9), length of 9, and start with 7 or 9
              if (
                /^\d*$/.test(value) &&
                value.length <= 9 &&
                (value === "" || value[0] === "7" || value[0] === "9")
              ) {
                setSenderPhone(value);
              }
            }}
            // type="Phone Number"
            // onChange={(e) => setSenderPhone(e.target.value)}
            // style={{ marginBottom: "10px" }}
          />
          <div className="b-p">
            <p>Star phone number with 9 or 7.. </p>
            <p>9/9</p>
          </div>
          {/* Receiver Information */}
          <TextField
            id="outlined-password-input"
            label="Receiver Name"
            type="text"
            value={receiverName}
            onChange={(e) => setReceiverName(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          <TextField
            id="outlined-password-input"
            label="+251"
            value={receiverPhone}
            type="tel"
            onChange={(e) => {
              const value = e.target.value;
              // Only allow digits (0-9), length of 9, and start with 7 or 9
              if (
                /^\d*$/.test(value) &&
                value.length <= 9 &&
                (value === "" || value[0] === "7" || value[0] === "9")
              ) {
                setReceiverPhone(value);
              }
            }}
            // onChange={(e) => setReceiverPhone(e.target.value)}
            // style={{ marginBottom: "10px" }}
          />
          <div className="b-p">
            <p>Star phone number with 9 or 7.. </p>
            <p>9/9</p>
          </div>
          {/* Description */}
          <TextField
            id="outlined-password-input"
            label="Description(optional)"
            placeholder="document,key,electronics,others...."
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            style={{ marginBottom: "10px" }}
          />
          {/* {!error.length == 0 ? (
            <Alert style={{ margin: "10px" }} severity="error">
              {error[0]}
            </Alert>
          ) : null} */}
          {/* Continue Button */}
          {/* <Button className="b-login-btn" size="small" onClick={handleContinue}>
            Continue
          </Button> */}

          {loading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Loading />
            </div>
          ) : (
            <Button
              className="b-login-btn"
              size="small"
              onClick={handleContinue}
            >
              Continue
            </Button>
          )}
          {!error.length == 0 ? (
            <Alert style={{ margin: "10px" }} severity="error">
              {error[0]}
            </Alert>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Courier;
